import type { IconData } from '@stacksjs/iconify-core'

export const creativeCommons: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 3a21 21 0 1 0 0 42a21 21 0 1 0 0-42\"/><path d=\"M24 8a16 16 0 1 0 0 32a16 16 0 1 0 0-32\"/><path d=\"M22 19.682c-1.712-1.079-8-1.626-8 4.318s6.288 5.397 8 4.317m12-8.635c-1.712-1.079-8-1.626-8 4.318s6.288 5.397 8 4.317\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default creativeCommons
